(function( $ ) {

	$.fn.actooltip = function( options ) {

		let set = $.extend( {
			'speed' : 200,
			'mode' : 'below',
			'space' : 70

		}, options );

		return this.each( function() {
			let $el = $( this );
			let mouseY = -1;
			$el.css( 'position', 'relative' );
			$( document ).on( 'mousemove', function( event ) {
				mouseY = event.clientY;
			} );
			let viewY = $( window ).height();

			$el.hover(
				function() {
					let tipr_cont = $( this ).find( '.actooltip' );

					$( window ).on( 'resize', function() {
						viewY = $( window ).height();
					} );

					let w_t = $( tipr_cont ).outerWidth();
					let w_e = $( this ).width();
					let m_l = (w_e / 2) - (w_t / 2);

					$( tipr_cont ).css( 'margin-left', m_l + 'px' );
					$( tipr_cont ).fadeIn( set.speed );
				},
				function() {
					$( this ).find( '.actooltip' ).fadeOut( 0 );
				}
			);
		} );
	};

})( jQuery );


